var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "cms-hero-block", style: _vm.sectionStyle },
    [
      _c(
        "div",
        { staticClass: "cms-hero-block__content", style: _vm.contentStyle },
        [
          _vm.headline
            ? _c("h1", { staticClass: "cms-hero-block__headline" }, [
                _vm._v(_vm._s(_vm.headline)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resolvedSubheadline
            ? _c("p", { staticClass: "cms-hero-block__subhead" }, [
                _vm._v(_vm._s(_vm.resolvedSubheadline)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.buttonText
            ? _c(
                "a",
                {
                  staticClass: "cms-hero-block__btn",
                  attrs: { href: _vm.buttonUrl || "#" },
                },
                [_vm._v(_vm._s(_vm.buttonText))]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }